module.exports = "/_next/static/images/7216044dbf28c5651a988ef506bcfa3e-faq-table.png.webp";